export default [
  { count: 753, date: '2020-03-24' },
  { count: 770, date: '2020-03-25' },
  { count: 973, date: '2020-03-26' },
  { count: 933, date: '2020-03-27' },
  { count: 844, date: '2020-03-28' },
  { count: 876, date: '2020-03-29' },
  { count: 1443, date: '2020-03-30' },
  { count: 1171, date: '2020-04-01' },
  { count: 1194, date: '2020-04-02' },
  { count: 1215, date: '2020-04-03' },
  { count: 1031, date: '2020-04-04' },
  { count: 990, date: '2020-04-05' },
  { count: 750, date: '2020-04-06' },
  { count: 754, date: '2020-04-07' },
  { count: 1231, date: '2020-04-08' },
  { count: 1398, date: '2020-04-09' },
  { count: 1388, date: '2020-04-10' },
  { count: 1232, date: '2020-04-11' },
  { count: 1128, date: '2020-04-12' },
  { count: 1350, date: '2020-04-13' },
  { count: 1233, date: '2020-04-14' },
  { count: 1591, date: '2020-04-15' },
  { count: 5020, date: '2020-04-30' },
  { count: 16184, date: '2020-04-16' },
  { count: 17749, date: '2020-04-17' },
  { count: 22323, date: '2020-04-18' },
  { count: 46555, date: '2020-04-19' },
  { count: 271762, date: '2020-04-20' },
  { count: 418506, date: '2020-04-21' },
  { count: 99757, date: '2020-04-22' },
  { count: 54271, date: '2020-04-23' },
  { count: 50980, date: '2020-04-24' },
  { count: 67302, date: '2020-04-25' },
  { count: 18181, date: '2020-04-26' },
  { count: 9843, date: '2020-04-27' },
  { count: 17361, date: '2020-04-28' },
  { count: 3101, date: '2020-04-29' },
  { count: 2086, date: '2020-05-11' },
  { count: 14585, date: '2020-05-12' },
  { count: 21465, date: '2020-05-18' },
  { count: 13117, date: '2020-05-17' },
  { count: 15883, date: '2020-05-16' },
  { count: 16369, date: '2020-05-15' },
  { count: 14392, date: '2020-05-14' },
  { count: 14780, date: '2020-05-13' },
  { count: 3644, date: '2020-05-01' },
  { count: 3744, date: '2020-05-02' },
  { count: 3595, date: '2020-05-03' },
  { count: 12357, date: '2020-05-04' },
  { count: 14530, date: '2020-05-05' },
  { count: 12701, date: '2020-05-06' },
  { count: 10455, date: '2020-05-07' },
  { count: 13915, date: '2020-05-08' },
  { count: 11937, date: '2020-05-09' },
  { count: 17308, date: '2020-05-10' },
  { count: 11770, date: '2020-05-19' },
  { count: 15357, date: '2020-05-20' },
  { count: 13463, date: '2020-05-21' },
  { count: 7419, date: '2020-05-22' },
  { count: 7635, date: '2020-05-23' },
  { count: 9676, date: '2020-05-24' },
  { count: 14139, date: '2020-05-25' },
  { count: 13747, date: '2020-05-26' },
  { count: 15333, date: '2020-05-27' },
  { count: 10062, date: '2020-05-28' },
  { count: 11123, date: '2020-05-29' },
  { count: 10305, date: '2020-05-30' },
  { count: 10891, date: '2020-05-31' },
  { count: 193, date: '2020-06-01' },
  { count: 6497, date: '2020-06-05' },
  { count: 10355, date: '2020-06-06' },
  { count: 11483, date: '2020-06-07' },
  { count: 15594, date: '2020-06-08' },
  { count: 10105, date: '2020-06-09' },
  { count: 9234, date: '2020-06-10' },
  { count: 9041, date: '2020-06-11' },
  { count: 11111, date: '2020-06-12' },
  { count: 14277, date: '2020-06-13' },
  { count: 10855, date: '2020-06-14' },
  { count: 12984, date: '2020-06-15' },
  { count: 13410, date: '2020-06-16' },
  { count: 19119, date: '2020-06-17' },
  { count: 13909, date: '2020-06-18' },
  { count: 10024, date: '2020-06-19' },
  { count: 15370, date: '2020-06-20' },
  { count: 13010, date: '2020-06-21' },
  { count: 22568, date: '2020-06-22' },
  { count: 21832, date: '2020-06-23' },
  { count: 16660, date: '2020-06-24' },
  { count: 10850, date: '2020-06-25' },
  { count: 11275, date: '2020-06-26' },
  { count: 10914, date: '2020-06-27' },
  { count: 6866, date: '2020-06-28' },
  { count: 25219, date: '2020-06-29' },
  { count: 15442, date: '2020-06-30' },
  { count: 9547, date: '2020-07-01' },
  { count: 9247, date: '2020-07-02' },
  { count: 12966, date: '2020-07-03' },
  { count: 10552, date: '2020-07-04' },
  { count: 11229, date: '2020-07-05' },
  { count: 8440, date: '2020-07-06' },
  { count: 7983, date: '2020-07-07' },
  { count: 10427, date: '2020-07-08' },
  { count: 8645, date: '2020-07-09' },
  { count: 8816, date: '2020-07-10' },
  { count: 6379, date: '2020-07-11' },
  { count: 7626, date: '2020-07-12' },
  { count: 10772, date: '2020-07-13' },
  { count: 8569, date: '2020-07-14' },
  { count: 12734, date: '2020-07-15' },
  { count: 6613, date: '2020-07-16' },
  { count: 9744, date: '2020-07-17' },
  { count: 7163, date: '2020-07-18' },
  { count: 5780, date: '2020-07-19' },
  { count: 11286, date: '2020-07-20' }
];
